import { listAllProperties, listAllPropertiesNext, searchProperties, searchPropertiesNext } from '../thunks/properties';
import { handlePending, handleRejected } from './utils';

export const propertiesReducers = (builder) => {
  // List all properties
  builder
    .addCase(listAllProperties.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.allProperties.value = files;
      state.allProperties.offset = offset;
      state.allProperties.hasMore = files.length > 0;
      state.allProperties.loading = false;
      state.allProperties.initialised = true;
    })
    .addCase(listAllProperties.pending, (state) => handlePending(state, 'allProperties'))
    .addCase(listAllProperties.rejected, (state) => handleRejected(state, 'allProperties'));

  // List all properties next
  builder
    .addCase(listAllPropertiesNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.allProperties.value = [...state.allProperties.value, ...files];
      state.allProperties.offset = offset;
      state.allProperties.hasMore = files.length > 0;
      state.allProperties.loading = false;
    })
    .addCase(listAllPropertiesNext.pending, (state) => handlePending(state, 'allProperties'))
    .addCase(listAllPropertiesNext.rejected, (state) => handleRejected(state, 'allProperties'));

  // search properties
  builder
    .addCase(searchProperties.fulfilled, (state, action) => {
      const properties = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.searchProperties.value = properties;
      state.searchProperties.offset = offset;
      state.searchProperties.hasMore = properties.length > 0;
      state.searchProperties.loading = false;
    })
    .addCase(searchProperties.pending, (state) => handlePending(state, 'searchProperties'))
    .addCase(searchProperties.rejected, (state) => handleRejected(state, 'searchProperties'));

  // search properties next
  builder
    .addCase(searchPropertiesNext.fulfilled, (state, action) => {
      const properties = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.searchProperties.value = [...state.searchProperties.value, ...properties];
      state.searchProperties.offset = offset;
      state.searchProperties.hasMore = properties.length > 0;
      state.searchProperties.loading = false;
    })
    .addCase(searchPropertiesNext.pending, (state) => handlePending(state, 'searchProperties'))
    .addCase(searchPropertiesNext.rejected, (state) => handleRejected(state, 'searchProperties'));
};
